module.exports = "/hwa/_next/static/images/van-9f97d9fc2d3cd66a8d7b6433cef6518a.png";